module.exports = __webpack_public_path__ + "media/images/home/4-33adf53ef6391d0c144d24c1cc4cb309.png";